import { render, staticRenderFns } from "./squeeze_hand_management.vue?vue&type=template&id=282fd20d&scoped=true&"
import script from "./squeeze_hand_management.vue?vue&type=script&lang=js&"
export * from "./squeeze_hand_management.vue?vue&type=script&lang=js&"
import style0 from "./squeeze_hand_management.vue?vue&type=style&index=0&id=282fd20d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282fd20d",
  null
  
)

export default component.exports